import { styled } from 'styled-components';

import { cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsSplitContentTextContent_Box_1 = styled.div`
  width: 100%;
  padding-block: ${gutterWidth / 4}px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    width: 50%;
    padding-inline: ${gutterWidth / 2}px;
    padding-block: ${gutterWidth / 2}px;
  }

  &[data-not-image-text-block] {
    padding-inline: ${gutterWidth / 4}px;

    @media all and (min-width: ${cssBreakpoints.smUp}) {
      padding-inline: ${gutterWidth / 2}px;
    }
  }

  &[data-image-text-block] {
    padding-block: ${gutterWidth / 2}px;
  }
`;
